import { Input } from '@/components/common/Input'
import { Textarea } from '@/components/common/Textarea'
import { StepShell, StepGrid } from '../StepShell'

const DEFAULT = {
  facial_symmetry: '',
  swelling: '',
  lymph_nodes: '',
  tmj_findings: '',
  mouth_opening: '',
}

export function ExtraOralStep({ value, onChange }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 7 — Phase 3"
      title="Extra oral examination"
      description="Findings observable on the face, jaw, and lymph nodes."
    >
      <StepGrid>
        <Input
          label="Facial symmetry"
          value={v.facial_symmetry}
          onChange={(e) => set({ facial_symmetry: e.target.value })}
          placeholder="e.g. Symmetrical"
        />
        <Input
          label="Swelling"
          value={v.swelling}
          onChange={(e) => set({ swelling: e.target.value })}
          placeholder="Site, size, consistency"
        />
        <Input
          label="Lymph nodes"
          value={v.lymph_nodes}
          onChange={(e) => set({ lymph_nodes: e.target.value })}
          placeholder="Non-palpable / tender / enlarged"
        />
        <Input
          label="TMJ findings"
          value={v.tmj_findings}
          onChange={(e) => set({ tmj_findings: e.target.value })}
          placeholder="Click / pain / deviation"
        />
        <Textarea
          label="Mouth opening"
          rows={2}
          value={v.mouth_opening}
          onChange={(e) => set({ mouth_opening: e.target.value })}
          placeholder="Inter-incisal distance, restriction"
          className="sm:col-span-2"
        />
      </StepGrid>
    </StepShell>
  )
}
